import { Route, Routes } from "react-router-dom";
import Geo from "./pages/geo";

export function CustomerGeoLocationsRoutes() {
	return (
		<Routes>
			<Route index element={<Geo />} />
		</Routes>
	);
}
